import { render, staticRenderFns } from "./createClass.vue?vue&type=template&id=17b2726d&scoped=true&"
import script from "./createClass.vue?vue&type=script&lang=js&"
export * from "./createClass.vue?vue&type=script&lang=js&"
import style0 from "./createClass.vue?vue&type=style&index=0&id=17b2726d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2726d",
  null
  
)

export default component.exports